"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TenantHelpseekersFormModule = /** @class */ (function () {
    function TenantHelpseekersFormModule() {
    }
    return TenantHelpseekersFormModule;
}());
exports.TenantHelpseekersFormModule = TenantHelpseekersFormModule;
